module.exports = __webpack_public_path__ + "img/logo_kbase-removebg.c3a4bc35.png";